<template>
  <div class="update-credentials-notification">
    <app-notification :title="'יש בעיה עם פרטי החשבונות.'"
                      :text="'אי אפשר לעדכן את התזרים כי חלק מפרטי החשבונות שאצלנו לא עובדים.'"
                      :notification-buttons="notificationButtons"
                      :footer-button="footerButton"
                      :icon-type="'danger'"/>
  </div>
</template>

<script>
import Intercom from '@/Intercom';
import Segment from '../../../../../../../Segment';
import AppNotification from '../AppNotification.vue';
import router from '../../../../../../../router';

export default {
  name: 'UpdateCredentialsNotification',
  components: {
    AppNotification,
  },
  async created() {
    Segment.trackUserGot('UpdateCredentialsNotificationShown');
    Segment.trackUserInteraction('JustInTimeCX_Shown', { source: this.$options.name });
  },
  computed: {
    footerButton() {
      return {
        title: 'לצ׳אט עם הצוות',
        variant: 'flat-black',
        size: 'slim',
        action: this.handleIntercomClickAction,
        // eslint-disable-next-line global-require
        icon: require('@/assets/icons/chat_icon_teriatry.svg'),
        id: 'cx-just-in-time-footer-button',
      };
    },
    notificationButtons() {
      return [
        {
          title: 'לעדכון פרטים',
          variant: 'primary',
          size: 'slim',
          action: this.goToCredentialsSettings,
        },
      ];
    },
  },
  methods: {
    goToCredentialsSettings() {
      Segment.trackUserInteraction('goToCredentialsSettingsClicked');
      router.push({ path: '/credentials' });
    },
    handleIntercomClickAction() {
      Segment.trackUserInteraction('JustInTimeCX_Clicked', { source: this.$options.name });
      Intercom.showNewMessage('היי רייזאפ,'
        + 'אשמח לעזרה עם עדכון החשבון שלי 🙏');
    },
  },
};

</script>

<style lang="scss" scoped>
.update-credentials-notification {
  ::v-deep .riseup-button .button-content .button-icon {
    display: inline-block;
    margin-left: 6px;
  }
}
</style>
